import { Typography, Button, Box } from "@mui/material";
import {blackColor, cardMustNotShowThisValue, greenColor, whiteColor} from "../../../constants/constants";
import { useAppDispatch, useAppSelector } from "../../../core/state/hooks";
import { selectDate } from "../../../core/state/date/dateSlice";
import { setWeekDayOfFirstDayOfMonth, fetchMonthlyRecords } from "../../../core/state/monthlyTracker/monthlyTrackerSlice";
import { fetchWeeklyRecords, navigateToOtherMonthDay, fetchWeeklyRecordsForDate, isSameWeekAsCurrent, updateCurrentWeekStart } from "../../../core/state/dailyTracker/dailyTrackerSlice";
import { isSameMonth, isSameWeek, startOfWeek} from 'date-fns';


const DayInfo = (props:{time:string, dayNumber:number, isInMonthLastPosition:boolean, isInOuterColumn:boolean, isAtLeft:boolean}) =>{
  const dispatch = useAppDispatch();
  const { selectedDate } = useAppSelector((state) => state.date);
  const { user: { id: userId } } = useAppSelector((state) => state.user);
  const { otherMonthDay, currentWeekStart, weekRecords } = useAppSelector((state) => state.dailyTracker);
  
  const isInMonthLastPosition = props.isInMonthLastPosition;
  const isAtLeft = props.isAtLeft;
  const isInOuterColumn = props.isInOuterColumn;
  const time = props.time;
  const dayNumber = props.dayNumber; 
  
  const firstDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const firstDayOfWeek = firstDayOfMonth.getDay();
  const daysFromPreviousMonth = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
  const daysInCurrentMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0).getDate();
  
  let thisDayDate: Date;
  let displayDayNumber: number;
  
  if (dayNumber <= daysFromPreviousMonth) {
    const lastMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 0);
    const lastDayOfPreviousMonth = lastMonth.getDate();
    displayDayNumber = lastDayOfPreviousMonth - daysFromPreviousMonth + dayNumber;
    thisDayDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, displayDayNumber);
  } else if (dayNumber > daysFromPreviousMonth + daysInCurrentMonth) {
    displayDayNumber = dayNumber - daysFromPreviousMonth - daysInCurrentMonth;
    thisDayDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, displayDayNumber);
  } else {
    displayDayNumber = dayNumber - daysFromPreviousMonth;
    thisDayDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), displayDayNumber);
  }
  const timeStringSlices = props.time.split(":");
  
  const isCurrentMonth = dayNumber > daysFromPreviousMonth && dayNumber <= daysFromPreviousMonth + daysInCurrentMonth;

  // Verificar si es el día activo - priorizar otherMonthDay si existe, sino usar selectedDate
  const isActiveDay = otherMonthDay ? 
    (otherMonthDay.getDate() === thisDayDate.getDate() && 
     otherMonthDay.getMonth() === thisDayDate.getMonth() && 
     otherMonthDay.getFullYear() === thisDayDate.getFullYear()) :
    (selectedDate && selectedDate.getDate() === thisDayDate.getDate() && 
     selectedDate.getMonth() === thisDayDate.getMonth() && 
     selectedDate.getFullYear() === thisDayDate.getFullYear());

  const updateWeekAndMaybeFetch = (date: Date, shouldFetchData: boolean, performFetch: () => void) => {
    if (!shouldFetchData) {
      return;
    }
    // En la vista mensual siempre debemos hacer fetch al cambiar de semana
    dispatch(updateCurrentWeekStart(startOfWeek(date, { weekStartsOn: 1 })));
    performFetch();
  }

  const fetchData = (date:Date)=>{
    const actual=selectedDate;

    // Calcular una sola vez si debemos obtener datos de la semana
    const shouldFetchData = !currentWeekStart || !isSameWeekAsCurrent(date, currentWeekStart);

    // Solo cambiar el mes si el día clickeado pertenece al mes actual
    if(isCurrentMonth){
      dispatch(selectDate(date));
      // Limpiar otherMonthDay cuando se selecciona un día del mes actual
      dispatch(navigateToOtherMonthDay(null));
      
      if(!isSameMonth(date,actual)){
        let firstDayOfMonth = new Date(date.getTime());
        firstDayOfMonth.setDate(1);
        let dayNumber = firstDayOfMonth.getDay();
        dispatch(setWeekDayOfFirstDayOfMonth(dayNumber));
        dispatch(fetchMonthlyRecords(userId));
      }

      updateWeekAndMaybeFetch(date, shouldFetchData, () => dispatch(fetchWeeklyRecords(userId)));
    } else {
      // Para días de otros meses, navegar a esa semana sin cambiar el mes del calendario
      // Incluir sábados y domingos para permitir navegación a esas semanas
      dispatch(navigateToOtherMonthDay(date));

      updateWeekAndMaybeFetch(
        date,
        shouldFetchData,
        () => dispatch(fetchWeeklyRecordsForDate({ idResource: userId, date }))
      );
    }
  }
  
  const styles = {
    dayButtonClicked: {color:whiteColor, backgroundColor:greenColor, borderRadius:7, minWidth:{xs:30,md:32,lg:35}, mx:"auto", p:{xs:2/8,md:3/8,lg:5/8}},
    dayButtonCurrentMonth: {color:blackColor, borderRadius:7, minWidth:{xs:30,md:32,lg:35}, mx:"auto", p:{xs:2/8,md:3/8,lg:5/8}},
    dayButtonOtherMonth: {color:"rgba(0,0,0,0.4)", borderRadius:7, minWidth:{xs:30,md:32,lg:35}, mx:"auto", p:{xs:2/8,md:3/8,lg:5/8}}
  }
  
  return <Box display={"flex"} flexDirection={"row"}  justifyContent={"center"} flex={1} minHeight={{xs: "3rem", md: "0rem"}} p={{xs:0.5, sm:1, md:1}} 
        borderBottom={"1px solid rgba(0, 0, 0, 0.03)"} className={isInMonthLastPosition? " border-b-0 m-b-15r" : "" + ((dayNumber !== cardMustNotShowThisValue)? " cursor-pointer" : "")}
        onClick={() => { 
          if (dayNumber !== cardMustNotShowThisValue){
            fetchData(thisDayDate)
          }
        }}>
      {(isInOuterColumn && dayNumber !== cardMustNotShowThisValue)? <Box display={"flex"} flexDirection={"column"} flex={isAtLeft? 0 : 0.5}></Box> : <></>}
      <Box display={"flex"} flex={1} flexDirection={"column"}  justifyContent={{xs:"end", md:"space-evenly"}}>
            {
              isActiveDay ?
              <Button sx={styles.dayButtonClicked}>
                <Typography className="" variant="h6">{displayDayNumber}</Typography> 
              </Button> :
              <Box>
                {
                  dayNumber !== cardMustNotShowThisValue?  
                  <Button sx={isCurrentMonth ? styles.dayButtonCurrentMonth : styles.dayButtonOtherMonth}>
                        <Typography variant="h6">{displayDayNumber}</Typography>
                  </Button>
                  :
                  <Box display={"flex"} flex={1} flexDirection={"column"}></Box>
                }
              </Box>
            }
            <Typography variant="subtitle2" sx={{color: isCurrentMonth ? blackColor : "rgba(0,0,0,0.3)", opacity: isCurrentMonth ? 0.6 : 0.4}} className={selectedDate && selectedDate.getDate() === thisDayDate.getDate() && selectedDate.getMonth() === thisDayDate.getMonth() && selectedDate.getFullYear() === thisDayDate.getFullYear() ? "" : ""}>
              {time && time !== "" && timeStringSlices[0] + ":" + timeStringSlices[1]}
            </Typography>
      </Box>
      {(isInOuterColumn && dayNumber !== cardMustNotShowThisValue)? <Box display={"flex"} flexDirection={"column"} flex={!isAtLeft? 0 : 0.5}></Box> : <></>}
    </Box>
}

export default DayInfo;